CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Control_UI_DropDown, },
    { code: CDN.PackageCode.Control_UI_HelpIcon, },
    { code: CDN.PackageCode.Control_UI_ToggleSwitch, },
    { code: CDN.PackageCode.Control_UI_Input, },
    { code: CDN.PackageCode.Control_UI_Icon, },
    { code: CDN.PackageCode.Control_UI_TimePicker, },
    { code: CDN.PackageCode.Control_UI_DateTimePicker, },
    { code: CDN.PackageCode.Control_UI_GridSelect, },
    { code: CDN.PackageCode.Control_UI_CycleSelect, },
    { code: CDN.PackageCode.Control_UI_MonthPicker, },
    { code: CDN.PackageCode.Control_UI_Spinner, },
    { code: CDN.PackageCode.Control_DataTable, },
    { code: CDN.PackageCode.Control_FlexBox, },
    { code: CDN.PackageCode.Control_TabbedPane, },
    { code: CDN.PackageCode.Control_UI_Button, },
    { code: CDN.PackageCode.Control_Dialog, },
    { code: CDN.PackageCode.Control_Charts_Pie, },
    { code: CDN.PackageCode.Drawing, },
    { code: CDN.PackageCode.Control_UI_CheckBox, },
], () => {
    let style = document.createElement("style");
    style.innerHTML = `
        .cdn-control-ui-testdiv {
            margin-bottom: 10px;
        }
    `;
    document.head.appendChild(style);


    let main = document.querySelector('main');

    let colorDiv = document.createElement("div");
    colorDiv.style.display = 'flex';
    for (let i = 0; i <= 100; i += 5) {
        let c = document.createElement("div");
        c.style.backgroundColor = `var(--cdn-grayscale-${i.toString().padLeft('0', 2)})`;

        c.style.color = i > 50 ? 'var(--cdn-grayscale-00)' : 'var(--cdn-grayscale-100)';

        c.style.textAlign = 'center';
        c.style.width = '40px';
        c.style.height = '25px';
        c.innerHTML = i.toString().padLeft('0', 2);
        colorDiv.appendChild(c);
    }
    main.appendChild(colorDiv);

    let modes = new CDN.Controls.Layout.FlexBox(main, {
        direction: 'column',
    });
    modes.add({ innerHtml: 'FlexLayout' });
    let nextRow = modes.add({ direction: 'row' });
    nextRow.add({ innerHtml: 'Danger', mode: CDN.Mode.Danger });
    nextRow.add({ innerHtml: 'Warning', mode: CDN.Mode.Warning });
    nextRow.add({ innerHtml: 'Success', mode: CDN.Mode.Success });

    let checkbox = new CDN.Controls.UI.CheckBox(main, {
        allowNull: true,
    });

    let piechart = new CDN.Controls.Charts.PieChart(main, {
        layers: [{
            name: 'test',
            segments: [],
            radiusRange: [0.6, 1.0],
            rotation: Math.PI / 12,
        }],
        onSelect: (segment) => {
            console.log(segment.label);
        }
    });

    piechart.container.style.width = '300px';

    for (let s = 0; s < 12; s++) {
        piechart.addSegment('test', {
            label: (s + "").padLeft('0', 2),
            startAngle: s * Math.PI / 6,
            endAngle: (s + 1) * Math.PI / 6,            
        })
    }

    let tabbedPane = new CDN.Controls.Layout.TabbedPane(main, {
        panes: [{
            heading: 'Tab1',
            content: 'Content1'
        },
        {
            heading: 'Tab2',
            content: 'Content2'
        }]
    });

    let data: [number, Date, string][] = [];
    for (let d = 0; d < 100; d++) {
        data.push([d, new Date().addDays(d), "Item_" + Math.floor(Math.random() * 1000).toString().padLeft('0', 3)]);
    }

    let button = new CDN.Controls.UI.Button(main, {
        text: 'Button',
    });

    let datatable = new CDN.Controls.DataTable.DataTable<[number, Date, string]>(main, {

        format: (v) => {
            return ["" + v[0], v[1]?.format('yyyy-MM-dd'), v[2]];
        },
        headings: () => ["Number", "Date", "String"],
        data: data,
        filter: true,
        pageSize: 10,
        sort: {
            defaultColumn: 1,
            allow: [false, true, true],
            fn: (column, a, b) => {
                switch (column) {
                    case 0:
                        return a[0] - b[0];
                    case 1:
                        return a[1].getTime() - b[1].getTime();
                    case 2:
                        return a[2].toLowerCase().localeCompare(b[2].toLowerCase());
                }
            },
        }
    });


    let helpIconDiv = document.createElement("div");
    main.appendChild(helpIconDiv);
    helpIconDiv.className = "cdn-control-ui-testdiv";
    helpIconDiv.innerHTML = "Help Icon";

    let helpIcon = new CDN.Controls.UI.HelpIcon(helpIconDiv, {
        help: "Some help text. Some help text. Some help text. Some help text. ",
    });

    let toggleSwitchDiv = document.createElement("div");
    main.appendChild(toggleSwitchDiv);
    toggleSwitchDiv.className = "cdn-control-ui-testdiv";

    let toggleSwitch = new CDN.Controls.UI.ToggleSwitch(toggleSwitchDiv, {
        callback: (on) => {
            output.innerHTML = "toggle switch " + (on ? "on" : "off");
        },
        label: "Toggle Switch",
    });

    let numericInputDiv = document.createElement("div");
    main.appendChild(numericInputDiv);
    numericInputDiv.className = "cdn-control-ui-testdiv";

    let numericInput = new CDN.Controls.UI.NumericInput(numericInputDiv, {
        label: "Numeric Input",
        maxVal: 100,
        minVal: 0,
        initialVal: 50,
        step: 1,
        callback: (val) => {
            output.innerHTML = "numeric input value is " + val;
        }
    });

    let textInputDiv = document.createElement("div");
    main.appendChild(textInputDiv);
    textInputDiv.className = "cdn-control-ui-testdiv";

    let textInput = new CDN.Controls.UI.TextInput<string>(textInputDiv, {
        label: "Text Input",
        placeholder: "Search",
        autocomplete: {
            minLength: 2,
            searchAsync: async (term) => {
                await CDN.Common.sleep(500);

                return [
                    {
                        label: term,
                        value: term,
                        data: "testdata01",
                    },
                    {
                        label: term + "...more",
                        value: term + "...more",
                        data: "testdata02",
                    },
                    {
                        label: term + "...even more",
                        value: term + "...even more",
                        data: "testdata03",
                    }
                ];
            },
        },
        callback: (val) => {
            output.innerHTML = "text input value is " + val;
        }
    });

    let dropDownDiv = document.createElement("div");
    main.appendChild(dropDownDiv);
    dropDownDiv.className = "cdn-control-ui-testdiv";

    let dropDown = new CDN.Controls.UI.DropDown.DropDown(dropDownDiv, {
        options: [
            { name: 'Option 1', value: '1' },
            { name: 'Option 2', value: '2' },
            { name: 'Option 3', value: '3' },
            { name: 'Option 4', value: '4' },
        ],
        onSelect: item => {
            output.innerHTML = `Dropdown ${item.name} (${item.value}) selected.`;
        },
    });

    let timePickerDiv = document.createElement("div");
    main.appendChild(timePickerDiv);
    timePickerDiv.className = "cdn-control-ui-testdiv";

    let timePicker = new CDN.Controls.UI.DateTime.TimePicker(timePickerDiv, {
        hour: {
            label: 'h',
            show: true,
            step: 1,
            value: 2,
        },
        minute: {
            label: 'm',
            show: true,
            step: 5,
        },
        second: {
            show: false,
        },
    });

    let gridSelectorDiv = document.createElement("div");
    main.appendChild(gridSelectorDiv);
    gridSelectorDiv.className = "cdn-control-ui-testdiv";
    let gridSelect = new CDN.Controls.UI.GridSelect.GridSelect(gridSelectorDiv, {
        rows: 4,
        columns: 3,
        html: (row, column) => CDN.Common.monthNames[row * 3 + column],
        value: (row, column) => row * 3 + column,
        onSelect: (row, column, value, html) => {
            outputDiv.innerHTML = `Output: ${html} (${value}) selected at (${row}, ${column})`;
        },
    });

    let cycleSelectDiv = document.createElement("div");
    main.appendChild(cycleSelectDiv);
    cycleSelectDiv.className = "cdn-control-ui-testdiv";
    let cycleSelect = new CDN.Controls.UI.CycleSelect.CycleSelect(cycleSelectDiv, {
        values: [{ value: "2020", name: "2020" }, { value: "2021", name: "2021" }, { value: "2022", name: "2022" }, { value: "2023", name: "2023" },],
        wrap: true,
    });

    let messageDlg = new CDN.Controls.Dialog.MessageDialog(main, {
        modal: true,
        title: 'Test Title',
        message: 'Test Message',
        buttonText: 'Ok',
    });

    let messageBtn = new CDN.Controls.UI.Button(main, {
        text: 'Message',
        icon: {
            type: 'material-symbol',
            symbol: 'message',
        },
        afterSelectionAsync: async (selected) => {
            await messageDlg.OpenAsync();
        }
    });

    let confirmDlg = new CDN.Controls.Dialog.ConfirmDialog(main, {
        modal: true,
        title: 'Test Title',
        question: 'Test Question',
        showCancel: true,
        showNo: true,
    });

    let confirmBtn = new CDN.Controls.UI.Button(main, {
        text: 'Confirm',
        icon: {
            type: 'material-symbol',
            symbol: 'question_mark',
        },
        afterSelectionAsync: async (selected) => {
            await confirmDlg.OpenAsync();
        }
    });

    setupIcons();

    let spinnerDiv = document.createElement("div");
    main.appendChild(spinnerDiv);
    let spinnerLabel = document.createElement('span');
    spinnerLabel.innerHTML = 'Spinner:';
    spinnerDiv.appendChild(spinnerLabel);
    let spinner = new CDN.Controls.UI.Spinner(spinnerDiv, {
        color: '#666',
        diameter: '30px',
        lineWidth: '6px',
    });

    let outputDiv = document.createElement("div");
    outputDiv.innerHTML = "Output: ";
    main.appendChild(outputDiv);
    let output = document.createElement("span");
    outputDiv.appendChild(output);
    outputDiv.className = "cdn-control-ui-testdiv";


    function setupIcons() {
        let materialSymbolHeading = document.createElement("div");
        main.appendChild(materialSymbolHeading);
        materialSymbolHeading.innerHTML = "Material Symbols";

        let msIconDiv = document.createElement("div");
        main.appendChild(msIconDiv);
        msIconDiv.className = "cdn-control-ui-testdiv";

        let materialSymbolIcon1 = new CDN.Controls.UI.Icon(msIconDiv, {
            type: "material-symbol",
            symbol: "help",
            style: "outlined",
            fontSize: "24px",
        });

        let materialSymbolIcon2 = new CDN.Controls.UI.Icon(msIconDiv, {
            type: "material-symbol",
            symbol: "video_camera_back",
            style: "outlined",
            fontSize: "24px",
        });

        let materialSymbolIcon3 = new CDN.Controls.UI.Icon(msIconDiv, {
            type: "material-symbol",
            symbol: "video_call",
            style: "outlined",
            fontSize: "24px",
        });

        let materialSymbolIcon4 = new CDN.Controls.UI.Icon(msIconDiv, {
            type: "material-symbol",
            symbol: "add_a_photo",
            style: "outlined",
            fontSize: "24px",
        });

        materialSymbolIcon1.container.style.display = "inline-block";
        materialSymbolIcon2.container.style.display = "inline-block";
        materialSymbolIcon3.container.style.display = "inline-block";
        materialSymbolIcon4.container.style.display = "inline-block";

        let imgIconDiv = document.createElement("div");
        main.appendChild(imgIconDiv);
        imgIconDiv.className = "cdn-control-ui-testdiv";
        imgIconDiv.innerHTML = "Image Icon";

        let imageIcon = new CDN.Controls.UI.Icon(imgIconDiv, {
            type: "image",
            src: "/shared/images/loading.gif",
        });

        let compositeIconHeading = document.createElement("div");
        main.appendChild(compositeIconHeading);
        compositeIconHeading.innerHTML = "Composite Icons";

        let compositeIconDiv = document.createElement("div");
        main.appendChild(compositeIconDiv);
        compositeIconDiv.className = "cdn-control-ui-testdiv";

        let compositeIcon1 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    left: "0px",
                    top: "3px",
                    symbol: "play_arrow",
                    zIndex: "2",
                    fontSize: "24px",
                    opticalSize: 48,
                },
            ]
        });
        let compositeIcon2 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    left: "5px",
                    top: "7px",
                    symbol: "timer_10_select",
                    zIndex: "2",
                    fontSize: "15px",
                    opticalSize: 48,
                },
            ]
        });
        let compositeIcon3 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "image",
                    src: "/shared/images/loading.gif",
                    position: "absolute",
                    left: "6px",
                    top: "0px",
                    zIndex: "2",
                    width: "13px",
                },
            ]
        });
        let compositeIcon4 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    left: "5px",
                    top: "8px",
                    symbol: "download",
                    zIndex: "2",
                    fontSize: "15px",
                    opticalSize: 48,
                },
            ]
        });
        let compositeIcon5 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    left: "4px",
                    top: "7px",
                    symbol: "cached",
                    zIndex: "2",
                    fontSize: "16px",
                    opticalSize: 48,
                },
            ]
        });
        let compositeIcon6 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "videocam",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    left: "4px",
                    top: "7px",
                    symbol: "priority_high",
                    zIndex: "2",
                    fontSize: "16px",
                    opticalSize: 48,
                },
            ]
        });
        let compositeIcon7 = new CDN.Controls.UI.Icon(compositeIconDiv, {
            type: "composite",
            position: "relative",
            icons: [
                {
                    type: "material-symbol",
                    position: "relative",
                    left: "0px",
                    top: "0px",
                    symbol: "interests",
                    zIndex: "2",
                    fontSize: "30px",
                    opticalSize: 48,
                },
                {
                    type: "material-symbol",
                    position: "absolute",
                    right: "2px",
                    top: "0px",
                    symbol: "location_on",
                    zIndex: "2",
                    fontSize: "16px",
                    opticalSize: 48,
                    fill: true,
                },
            ]
        });

        compositeIcon1.container.style.display = "inline-block";
        compositeIcon2.container.style.display = "inline-block";
        compositeIcon3.container.style.display = "inline-block";
        compositeIcon4.container.style.display = "inline-block";
        compositeIcon5.container.style.display = "inline-block";
        compositeIcon6.container.style.display = "inline-block";
        compositeIcon7.container.style.display = "inline-block";
    }
});